import { apiCall } from '../utils/apiUtils';

export const feedbackService = {
    /**
     * Submit feedback to the API
     * @param {Object} feedbackData - The feedback data
     * @returns {Promise} API response
     */
    submitFeedback: async (feedbackData) => {
        return await apiCall('/submit-feedback', feedbackData, {
            method: 'POST'
        });
    },

    /**
     * Get all feedback (admin only)
     * @param {Object} params - Query parameters (page, page_size, filter)
     * @returns {Promise} API response with feedback list
     */
    getFeedback: async (params = {}) => {
        return await apiCall('/get-feedback', null, {
            method: 'GET',
            params: params,
            forceAuth: true  // Always require authentication for this endpoint
        });
    },

    /**
     * Update feedback workflow status (admin only)
     * @param {{ id: string, status: string }} payload
     */
    updateFeedbackStatus: async (payload) => {
        return await apiCall('/update-feedback', payload, {
            method: 'PATCH',
            forceAuth: true,
        });
    },
};

export default feedbackService; 